"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _helpers = require("../../util/helpers");

var _types = require("../../util/types");

var _InputChip = _interopRequireDefault(require("../InputChip/InputChip"));

var _ListInput = _interopRequireDefault(require("./ListInput"));

require("./AddressInput.scss");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(n); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var AddressInput = function AddressInput(_ref) {
  var label = _ref.label,
      list = _ref.list,
      selected = _ref.selected,
      onSelect = _ref.onSelect,
      onEdit = _ref.onEdit,
      _onDelete = _ref.onDelete,
      emptyListLabel = _ref.emptyListLabel;

  var _useState = (0, _react.useState)(''),
      _useState2 = _slicedToArray(_useState, 2),
      value = _useState2[0],
      setValue = _useState2[1];

  var inputRef = (0, _react.useRef)();
  var editRef = (0, _react.useRef)();

  var selectContact = function selectContact(contact) {
    if ((0, _helpers.isValidMail)(contact.account)) {
      onSelect(contact);
    } else {
      onSelect(_objectSpread(_objectSpread({}, contact), {}, {
        invalid: true
      }));
    }

    setValue('');
  };

  var _useState3 = (0, _react.useState)(null),
      _useState4 = _slicedToArray(_useState3, 2),
      editing = _useState4[0],
      setEditing = _useState4[1];

  (0, _react.useEffect)(function () {
    if (editing !== null) editRef.current.focus();
  }, [editing]);

  var editContact = function editContact(i, c) {
    onEdit(i, _objectSpread(_objectSpread({}, c), {}, {
      invalid: !(0, _helpers.isValidMail)(c.account)
    }));
    setEditing(null);
  };

  var blurEditing = function blurEditing(i, c) {
    if (c.account === '') {
      _onDelete(i);

      setEditing(null);
    }
  };

  var propagationWrapper = function propagationWrapper(e, action) {
    e.stopPropagation();
    action();
  };

  var inputID = 'uin-ain-input-' + label.replace(/\s+/g, '');
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "uin-address-input",
    onClick: function onClick() {
      return inputRef.current.focus();
    }
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: "uin-ain-label"
  }, label, ":"), /*#__PURE__*/_react["default"].createElement("div", {
    className: "uin-ain-addresses"
  }, selected.map(function (c, i) {
    return editing === i ? /*#__PURE__*/_react["default"].createElement(_ListInput["default"], {
      key: i,
      id: inputID + i,
      ref: editRef,
      adjustable: true,
      list: list,
      value: c.account,
      onClick: function onClick(e) {
        return e.stopPropagation();
      },
      onChange: function onChange(e) {
        return onEdit(i, _objectSpread(_objectSpread({}, c), {}, {
          account: e.currentTarget.value
        }));
      },
      onSelect: function onSelect(c) {
        return editContact(i, c);
      },
      onBlur: function onBlur() {
        return blurEditing(i, c);
      },
      emptyListLabel: emptyListLabel
    }) : /*#__PURE__*/_react["default"].createElement(_InputChip["default"], {
      key: i,
      label: c.account,
      interactive: true,
      invalid: c.invalid,
      onClick: function onClick(e) {
        return propagationWrapper(e, function () {
          return setEditing(i);
        });
      },
      onDelete: function onDelete(e) {
        return propagationWrapper(e, function () {
          return _onDelete(i);
        });
      }
    });
  }), /*#__PURE__*/_react["default"].createElement(_ListInput["default"], {
    id: inputID,
    ref: inputRef,
    list: list,
    value: value,
    onChange: function onChange(e) {
      return setValue(e.currentTarget.value);
    },
    onSelect: selectContact,
    emptyListLabel: emptyListLabel
  })));
};

AddressInput.propTypes = {
  label: _propTypes["default"].string.isRequired,
  selected: _propTypes["default"].arrayOf(_types.contactType),
  list: _propTypes["default"].arrayOf(_types.contactType),
  onSelect: _propTypes["default"].func.isRequired,
  onEdit: _propTypes["default"].func.isRequired,
  onDelete: _propTypes["default"].func.isRequired
};
AddressInput.defaultProps = {
  selected: []
};
var _default = AddressInput;
exports["default"] = _default;


//////////////////
// WEBPACK FOOTER
// ./~/global-components-library/dist/components/AddressInput/AddressInput.js
// module id = 1880
// module chunks = 0